import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MapIcon from '@mui/icons-material/Map';
import CampaignIcon from '@mui/icons-material/Campaign';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import PolylineIcon from '@mui/icons-material/Polyline';
import Header from '../../components/Header/Header';

import './About.scss';

function About() {
  const navigate = useNavigate();
  const { isAuthorized } = useContext(AuthContext);

  const agentGoals = [
    {
      key: "ag-1",
      icon: <PolylineIcon />,
      description: "Identificar sua área de trabalho."
    },
    {
      key: "ag-2",
      icon: <CampaignIcon />,
      description: "Inspecionar as denúncias feitas por outros usuários e delegadas à você pelo seu supervisor."
    },
    {
      key: "ag-3",
      icon: <ImageSearchIcon />,
      description: "Registrar possíveis focos de vetores transmissores de doença dentro de sua área de trabalho."
    },
    {
      key: "ag-4",
      icon: <MapIcon />,
      description: "Ficar de olho no mapa da cidade e nos focos reportados pelos usuários."
    }
  ];
  const projectURL = "https://voceagente.fiocruz.br";
  const projectTermsServiceURL = "https://voceagente.fiocruz.br/politica-de-privacidade/";

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  return (
    <div className="inner-page about-page">
      <Header
        showBackBtn
        hideBackBtnLabel
        pageTitle="Sobre"
      />
      <div className="inner-page-content-container">
        <Accordion className="item">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>O que é a Plataforma Você Agente?</Typography>
          </AccordionSummary>
          <AccordionDetails className="item-details">
            <Typography>
              Ela é um conjunto de apps que trabalham em sintonia.
            </Typography>
            <Typography>
              Ele é composta pelo Aplicativo da População, Aplicativo do Agente <b>(este app)</b> e o Aplicativo do Gestor.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className="item">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>Quais são minhas funções aqui no App do Agente?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {
                agentGoals.map(goal => {
                  return (
                    <ListItem key={goal.key}>
                      <ListItemIcon>
                        {goal.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={goal.description}
                      />
                    </ListItem>
                  );
                })
              }
            </List>
          </AccordionDetails>
        </Accordion>
        <Accordion className="item">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel3a-header"
          >
            <Typography>Onde encontro mais informações sobre a plataforma?</Typography>
          </AccordionSummary>
          <AccordionDetails className="item-details">
            <Link
              target="blank_"  
              href={projectURL}
            >Clique aqui para mais informações</Link>
          </AccordionDetails>
        </Accordion>
        <Accordion className="item">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel4a-header"
          >
            <Typography>Onde estão os termos de serviço?</Typography>
          </AccordionSummary>
          <AccordionDetails className="item-details">
            <Link
              target="blank_"  
              href={projectTermsServiceURL}
            >Clique aqui para mais informações</Link>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default About;
